// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".showpopou[data-v-d7a9fec4]{height:100%}.showpopou div[data-v-d7a9fec4]{width:100%;height:100%}.showpopou img[data-v-d7a9fec4]{width:100%}", ""]);
// Exports
module.exports = exports;
